import { render, staticRenderFns } from "./PaymentInfoItem.vue?vue&type=template&id=8fae3832&scoped=true&"
import script from "./PaymentInfoItem.vue?vue&type=script&lang=js&"
export * from "./PaymentInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInfoItem.vue?vue&type=style&index=0&id=8fae3832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fae3832",
  null
  
)

export default component.exports